import {action, makeAutoObservable, observable} from "mobx"

export enum ToolBarButtonType {
    APP, DOSC
}

class ToolBarStore {
    @observable private selectedButton: ToolBarButtonType = ToolBarButtonType.APP

    constructor() {
        makeAutoObservable(this)
    }

    getSelectedButton(): ToolBarButtonType {
        return this.selectedButton
    }

    @action
    setButton(selectedButton: ToolBarButtonType) {
        this.selectedButton = selectedButton
    }
}

export const toolBarStore: ToolBarStore = new ToolBarStore()
